import effectManager from '../module/effect';

let effect = new effectManager();

/* ---------------------------------------

    --

--------------------------------------- */
export default class MovieManager {
    constructor() {

        this.$container = $("#p-movie");
        this.$close = $("#p-movie-close");

        this.$playBtn =  $("#p-movie-console-play");
        this.$seekbar =  $("#p-movie-console-seekbar-gauge-current");
        this.$sound =  $("#p-movie-console-sound");


        this.status = {
            mouse : {
              x : 0,
              y : 0
            },
            console: {
                flg : false,
                time:0,
            },
            seekbar : {
                currentTime : 0,
                totalTime : 0,
                parsent   : 0
            }
        }

    }
    init(){

        this.close();
        // this.uiClose();
        TweenMax.set(this.$container.find(".outline.type-x >*"),{
            x:-101+"%",
        })
        TweenMax.set(this.$container.find(".outline.type-y >*"),{
            y:-101+"%",
        })


    }
    open(){


        TweenMax.to(this.$container,0.4,{
            opacity:1,
            ease:Power2.easeOut,
            onComplete:()=>{
                if(Useragnt.tablet) this.uiOpen();
            }
        })


    }
    uiOpen(){
        if(this.status.console.flg||Useragnt.mobile) return;
        this.status.console.flg = true;
        this.status.console.time = 0;
        effect.show(this.$container.find(".js__show__inner"),"show");

        TweenMax.to(this.$container.find(".outline.type-x >*"),0.4,{
            x:0+"%",
            ease:Power2.easeOut
        })
        TweenMax.to(this.$container.find(".outline.type-y >*"),0.4,{
            y:0+"%",
            ease:Power2.easeOut
        })
    }
    close(){


        TweenMax.to(this.$container,0.4,{
            opacity:0,
            ease:Power2.easeOut,
            delay:0.2,
            onComplete:()=>{
                 this.status.console.time=0;
                this.status.mouse.flg = false;
                this.uiClose();
            }
        })


    }
    uiClose(){
        if(!this.status.console.flg||Useragnt.mobile) return;
        this.status.console.flg = false;
        effect.show(this.$container.find(".js__show__inner"),"out");

        TweenMax.to(this.$container.find(".outline.type-x >*"),0.4,{
            x:-101+"%",
            ease:Power2.easeOut
        })
        TweenMax.to(this.$container.find(".outline.type-y >*"),0.4,{
            y:-101+"%",
            ease:Power2.easeOut
        })
    }
    render(movieTime,mouse){

        if(Useragnt.mobile) return;

        this.status.seekbar.currentTime = movieTime;
        this.status.seekbar.parsent = this.status.seekbar.currentTime/this.status.seekbar.totalTime*100;
        if(this.status.seekbar.parsent>0){
            TweenMax.set(this.$seekbar,{x : -98 + this.status.seekbar.parsent + "%" })
        }else{
            TweenMax.set({x:-100 + "%"})
        }
        this.status.console.time += 1;

        if(Useragnt.tablet) return;

        if(this.status.mouse.flg&&this.status.mouse.x != mouse.x||this.status.mouse.flg&&this.status.mouse.y != mouse.y){
            if(!this.status.console.flg) this.uiOpen();
            this.status.console.time = 0;
        }

        this.status.mouse.x = mouse.x;
        this.status.mouse.y = mouse.y;
        if(this.status.console.time>180) this.status.mouse.flg = true;

        if(this.status.console.time>60&&this.status.console.flg){
            this.uiClose();
        }

    }

}